import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPagesService } from './pages.interface';
import { Router } from '@angular/router';
import * as Http from 'src/app/@framework/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

import { Joove } from 'src/app/@framework/core/Joove';
import { AuthService } from '@services/Auth.service';

@Injectable({ providedIn: 'root'})

export class PagesService implements IPagesService
{
    constructor(private httpClient: HttpClient, private authService: AuthService, private router: Router) {
    }

    refreshContext(page: string, action: string): Observable<Joove.IContext> {
        return this.httpClient
          .get(environment.appUrl + page + `/_Context_` + action, Http.zAppDevGetActionOptions)
          .pipe(map((data: any) => {
            data.body.currentUser = JSON.parse(data.body.currentUser);
            if (environment.windowsAuthentication == false && this.authService.isLoggedIn() && (data.body.currentUser == null || data.body.currentUser.UserName == null)) {
                this.authService.logout();
                this.router.navigate(['/']);
            }
            return data.body;
        }));
    }
}